module.exports = __webpack_public_path__ + "static/media/deck_pampa.ba0d588d.jpg";